



















































































































import { Component, Vue } from 'vue-property-decorator';
import Main from '../components/organization/Main.vue';
import TccSection from '../components/tccSection/index.vue';

// Import data files for both semesters
import { apresentacoes_TCC as apresentacoes_TCC_2023_2 } from '@/storage/programacao/TCCs_2023_2';
import { apresentacoes_TCC as apresentacoes_TCC_2024_1 } from '@/storage/programacao/TCCs_2024_1';

@Component({
  components: {
    Main,
    TccSection
  }
})
export default class TCC extends Vue {
  private selectedSemester: string = '2024/1';
  private tipo_TCC: number = 2;
  private ultima_data: string | null = null;
  private all_tccs: any[] = [];
  private filtered_tccs: any[] = [];

  mounted() {
    this.loadData();
  }

  handleChange() {
    this.loadData();
  }

  loadData() {
    // Determine which data to use based on selected semester
    if (this.selectedSemester === '2023/2') {
      this.all_tccs = apresentacoes_TCC_2023_2;
    } else if (this.selectedSemester === '2024/1') {
      this.all_tccs = apresentacoes_TCC_2024_1;
    }

    // Apply filters based on tipo_TCC and ultima_data
    this.applyFilters();
  }

  applyFilters() {
    if (this.ultima_data === null) {
      this.filtered_tccs = this.all_tccs.map(item => ({
        ...item,
        tccs: item.tccs.filter(aux => aux.tipoTCC === this.tipo_TCC)
      }));
    } else {
      this.filtered_tccs = this.all_tccs.map(item => ({
        ...item,
        tccs: item.tccs.filter(aux => aux.date === this.ultima_data && aux.tipoTCC === this.tipo_TCC)
      }));
    }
  }

  filterPalestras(e) {
    let data = e.target.innerText;
    this.ultima_data = data;
    this.applyFilters();
  }

  clearFilter() {
    this.ultima_data = null;
    this.applyFilters();
  }

  filtrarTCC1() {
    this.tipo_TCC = 1;
    document.getElementById("myText").textContent = "As apresentações de TCC I não são públicas. As mesmas ocorrerão na plataforma Microsoft Teams, equipe Mural de Avisos - Escola Politécnica e de Artes, canal Apresentações de TCC I 2024-1";
    this.applyFilters();
  }

  filtrarTCC2() {
    this.tipo_TCC = 2;
    document.getElementById("myText").textContent = "";
    this.applyFilters();
  }
}
